import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { RecordVideoDialogComponent } from '../record-video-dialog/record-video-dialog.component';
import { AddTask } from '@app/store/tasks/tasks.actions';
import { Store } from '@ngxs/store';
import Utils from '@app/shared/utils/utils';

@Component({
  selector: 'app-upload-videos-mobile',
  templateUrl: './upload-videos-mobile.component.html',
  styleUrls: ['./upload-videos-mobile.component.sass'],
})
export class UploadVideosMobileComponent {
  @Input() idTrade!: string;
  uploadSuccess = false;

  constructor(private dialog: MatDialog, private store: Store) {}

  openVideoRecording(): void {
    const dialogRef = this.dialog.open(RecordVideoDialogComponent, {
      width: '100vw',
      maxWidth: '100vw',
      height: '100vh',
      panelClass: 'full-screen-dialog',
    });

    dialogRef.afterClosed().subscribe((videoFile: File | null) => {
      if (videoFile && videoFile.size > 0) {
        this.uploadVideo(videoFile);
      }
    });
  }

  /**
   * @param videoFile
   */
  private uploadVideo(videoFile: File): void {
    const fullFilename = videoFile.name;
    const payload = this.createUploadPayload(videoFile, fullFilename);

    this.store
      .dispatch(
        new AddTask({
          name: payload.videoName,
          file: payload.blobRec,
          uploadPayload: payload,
          getPresignedApiUrlService: 'COLLECT.postGeneratePresignedUrl',
          preSignedRequest: {
            contentType: payload.fileType,
            filename: fullFilename,
            idTrade: this.idTrade,
          },
          updateGalleryApiUrlService: 'COLLECT.postRegisterUploadedMedia',
          updateTradeGalleryRequest: {
            idTrade: this.idTrade,
            filename: fullFilename,
          },
          successMessage: `Arquivo ${payload.videoName} finalizado com sucesso.`,
          errorMessage: `Não foi possível enviar a evidência ${payload.videoName}. Por favor, tente novamente.`,
        })
      )
      .subscribe({
        error: (error) => console.error('Erro no upload:', error),
      });
  }

  /**
   * @param videoFile
   * @param fullFilename
   * @returns
   */
  private createUploadPayload(videoFile: File, fullFilename: string): any {
    return {
      idTrade: this.idTrade,
      blobRec: videoFile,
      videoName: fullFilename.split('/').pop() || videoFile.name,
      fileType: videoFile.type || 'video/webm',
    };
  }
}
